import { Alert, Button, DialogFooter } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onLogout: () => void;
};

/**
 * Содержимое окна установки постоянного пароля, когда срок временного пароля истёк:
 * заменить его уже нельзя, новый пароль задаёт администратор.
 */
export const TemporaryPasswordExpired: FC<Props> = ({ onLogout }) => {
  const { t } = useTranslation('auth');

  return (
    <div className="flex flex-col gap-4">
      <Alert
        type="error"
        title={t('tempPasswordModal.expiredTitle')}
        description={t('tempPasswordModal.expiredDescription')}
      />
      <DialogFooter>
        <Button className="w-full" onClick={onLogout}>
          {t('tempPasswordModal.logout')}
        </Button>
      </DialogFooter>
    </div>
  );
};
